<ng-template #modalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{title}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="m-t-10" style="text-align: right">
      <button type="button" class="btn btn-success" [disabled]="totalSelected.length == 0 || loading"  (click)="Download()">
        <i *ngIf="loading" class="fa fa-spinner fa-spin m-r-5"></i>
        ดาวน์โหลด XML
      </button>
      <button type="button" class="btn btn-primary" (click)="selectAll()">เลือกทั้งหมด</button>
    </div>
    <table class="table table-striped m-t-30">
      <thead>
      <tr style="color: #ffffff; background-color: #036BB3; text-align: center">
        <th scope="col" style="width: auto">ลำดับ</th>
        <th scope="col" style="width: auto">เลขที่เอกสาร</th>
        <th scope="col">ชื่อผู้ซื้อ</th>
        <th scope="col">เลขที่ผู้เสียภาษี</th>
        <th scope="col">วันที่ออกเอกสาร</th>
        <th scope="col">มูลค่า</th>
        <th scope="col">ภาษี</th>
        <th scope="col">รวม</th>
        <th scope="col" style="text-align: center">เลือก</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let res of list; let index = index" style="text-align: center">
        <td>{{((currentPage - 1) * 10) + index + 1}}</td>
        <td>{{res.header_invoice_number}}</td>
        <td>{{res.buyer_name}}</td>
        <td>{{res.buyer_tax_id}}</td>
        <td>{{res.header_issue_dt | date:"dd/MM/yyyy HH:mm" }}</td>
        <td>{{res.total_items_net_line_exclude_vat}}</td>
        <td>{{res.total_items_vat}}</td>
        <td>{{res.total_items_total_payment}}</td>
        <td style="text-align: center">
          <input type="checkbox" [(ngModel)]="selectedValues[res.id]" (change)="selectChild(res.id)">
        </td>
      </tr>
      </tbody>
    </table>
    <div class="pagination m-t-10 col-md-12">
      <ngb-pagination [collectionSize]="totalItems" [(page)]="currentPage" [maxSize]="10"
                      (pageChange)="pageChanged()" aria-label="Default pagination"></ngb-pagination>
    </div>
  </div>
</ng-template>





// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/grouped-list-detail/grouped-list-detail.component.html